export default __webpack_public_path__ + "static/media/mobile.829435ea.svg";